"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lexer = void 0;
const moo_1 = __importDefault(require("moo"));
exports.lexer = moo_1.default.compile({
    WS: { match: /[\s]+/, lineBreaks: true },
    comment: /\/\/.*?$/,
    number: /[+-]?(?:(?:[0-9]*\.[0-9]+)|[1-9][0-9]*|(?:0))/,
    stringdouble: /"(?:\\["\\]|[^\n"\\])*"/,
    stringsingle: /'(?:\\['\\]|[^\n'\\])*'/,
    property: /\.[a-zA-Z_0-9]+/,
    identifier: {
        match: /[a-zA-Z]+[a-zA-Z_0-9]*/,
        type: moo_1.default.keywords({
            booltrue: "true",
            boolfalse: "false",
            // pxServer replaces "and" and "or" with "&&" and "||" before parsing as syntax.
            and: "and",
            or: "or",
        }),
    },
    lparen: "(",
    rparen: ")",
    lsquarebracket: "[",
    rsquarebracket: "]",
    colon: ":",
    comma: ",",
    or: "||",
    and: /&&|&amp;&amp;/,
    equal: "==",
    notequal: "!=",
    not: "!",
    greaterthanorequal: />=|&gt;=/,
    lessthanorequal: /<=|&lt;=/,
    greaterthan: />|&gt;/,
    lessthan: /<|&lt;/,
    multiply: "*",
    divide: "/",
    modulus: "%",
    subtract: "-",
    add: "+",
    question: "?",
});
//# sourceMappingURL=lexer.js.map